﻿// /wwwroot/js/components/newsletter.js
/* CommonJS, no globals, no auto-init */
module.exports = (function () {
    'use strict';

    // why: avoid duplicate listeners on hot reload / repeated init calls
    var wired = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

    var DEFAULTS = {
        selectors: {
            form: 'form[data-newsletter]',
            email: '#mce-EMAIL',
            error: '#mce-EMAIL-error'
        },
        messages: {
            required: 'Email is required.',
            invalid: 'Please enter a valid email address.'
        },
        // lightweight sanity check, not RFC-complete
        emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    };

    function merge(target, src) {
        if (!src) return target;
        var out = Object.assign({}, target);
        if (src.selectors) out.selectors = Object.assign({}, target.selectors, src.selectors);
        if (src.messages) out.messages = Object.assign({}, target.messages, src.messages);
        if (src.emailRegex) out.emailRegex = src.emailRegex;
        return out;
    }

    function isValidEmail(inputEl, emailRegex) {
        var val = (inputEl.value || '').trim();
        // `checkValidity` may be false if `required`/type=email fails
        return inputEl.checkValidity() && emailRegex.test(val);
    }

    function showError(emailEl, errorBox, msg) {
        errorBox.textContent = msg;            // why: ensures screen readers announce via live region
        emailEl.setAttribute('aria-invalid', 'true');
        emailEl.classList.add('input-error');
    }

    function clearError(emailEl, errorBox) {
        errorBox.textContent = '';
        emailEl.removeAttribute('aria-invalid');
        emailEl.classList.remove('input-error');
    }

    function wire(form, cfg) {
        if (!form) return;
        if (wired && wired.has(form)) return;   // why: idempotent init

        var email = form.querySelector(cfg.selectors.email);
        var errorBox = form.querySelector(cfg.selectors.error);
        if (!email || !errorBox) return;

        var onInput = function () {
            if (isValidEmail(email, cfg.emailRegex)) clearError(email, errorBox);
        };

        var onBlur = function () {
            var val = (email.value || '').trim();
            if (!val) {
                showError(email, errorBox, cfg.messages.required);
            } else if (!isValidEmail(email, cfg.emailRegex)) {
                showError(email, errorBox, cfg.messages.invalid);
            } else {
                clearError(email, errorBox);
            }
        };

        var onSubmit = function (e) {
            var val = (email.value || '').trim();
            if (!val) {
                e.preventDefault();
                showError(email, errorBox, cfg.messages.required);
                email.focus();
                return;
            }
            if (!isValidEmail(email, cfg.emailRegex)) {
                e.preventDefault();
                showError(email, errorBox, cfg.messages.invalid);
                email.focus();
                return;
            }
            clearError(email, errorBox); // allow submit to proceed
        };

        // store refs so we can detach if needed
        form.__newsletterHandlers = { onInput: onInput, onBlur: onBlur, onSubmit: onSubmit, email: email, errorBox: errorBox };

        email.addEventListener('input', onInput);
        email.addEventListener('blur', onBlur);
        form.addEventListener('submit', onSubmit);

        if (wired) wired.add(form);
    }

    function init(root, options) {
        var cfg = merge(DEFAULTS, options);
        var scope = root && root.querySelectorAll ? root : document;
        // direct form provided
        if (root && root.tagName === 'FORM') {
            wire(root, cfg);
            return;
        }
        var forms = scope.querySelectorAll(cfg.selectors.form);
        for (var i = 0; i < forms.length; i++) wire(forms[i], cfg);
    }

    function destroy(root, options) {
        var cfg = merge(DEFAULTS, options);
        var scope = root && root.querySelectorAll ? root : document;
        var forms = root && root.tagName === 'FORM'
            ? [root]
            : scope.querySelectorAll(cfg.selectors.form);

        for (var i = 0; i < forms.length; i++) {
            var form = forms[i];
            var h = form.__newsletterHandlers;
            if (!h) continue;
            h.email.removeEventListener('input', h.onInput);
            h.email.removeEventListener('blur', h.onBlur);
            form.removeEventListener('submit', h.onSubmit);
            delete form.__newsletterHandlers;
            if (wired) wired.delete && wired.delete(form);
        }
    }

    // alias for themes expecting `.initialize()`
    function initialize(root, options) { return init(root, options); }

    return {
        init: init,
        initialize: initialize,
        destroy: destroy
    };
})();
